/**
 * This module exports an empty function for use when providing functions
 * as default props without adding uncovered code.
 *
 * We define our own noop rather than using Function.prototype due to the
 * performance benefits (source: https://stackoverflow.com/a/33458430).
 */
export default () => {}
